import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { CREATE_STORE } from './types';

export const createStore = createTaskAction(CREATE_STORE);
